<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <router-view />
    <Notifications />
    <DebugPanel v-if="isDevelopment && showDebugPanel" />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import Notifications from '@/components/common/Notifications.vue'
import DebugPanel from '@/components/DebugPanel.vue'

const authStore = useAuthStore()

// Show debug panel only in development mode
const isDevelopment = computed(() => import.meta.env.DEV)
const showDebugPanel = ref(false)

// Add global keyboard shortcut to toggle debug panel
onMounted(() => {
  // Check if user is already logged in
  authStore.checkAuth()

  // Toggle debug panel with Ctrl+Shift+D
  document.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.shiftKey && e.key === 'D') {
      e.preventDefault()
      showDebugPanel.value = !showDebugPanel.value
    }
  })

  // Show debug panel automatically in development if there are errors
  if (isDevelopment.value) {
    console.log('🐛 Debug Panel available! Press Ctrl+Shift+D to toggle')
  }
})
</script>

<style>
#app {
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>